import { APP_NAME } from "@mirage/shared/util/build-vars";
import { createContext, useContext, useEffect } from "react";

export function useDashTitle(title?: string) {
  const titleContext = useDashTitleContext();
  useEffect(() => {
    const oldTitle = document.title;

    // No need i18n for product name.
    const newTitle = title ? `${title} - ${APP_NAME}` : APP_NAME;
    document.title = newTitle;
    titleContext?.didUpdateTitle(newTitle);

    return () => {
      document.title = oldTitle;
      titleContext?.didUpdateTitle(oldTitle);
    };
  }, [title, titleContext]);
}

interface DashTitleContextInterface {
  didUpdateTitle: (title: string) => void;
}
export const DashTitleContext = createContext<
  DashTitleContextInterface | undefined
>(undefined);

const useDashTitleContext = () => useContext(DashTitleContext);
